module.exports = __webpack_public_path__ + "static/terms_of_service_for_operation_control_in_bank_131_archive-62481acf1c88a4c80d8830365fa1017e.pdf";